import { Result, Space, Typography } from 'antd';
import ClaimSubmitErrorIcon from 'assets/images/newClaim/claim-submit-error.svg';
import { PrimaryButton, SecondaryButton } from 'components/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const { Paragraph } = Typography;

interface SubmitErrorPageProps {
  handleOnStartOver: () => void;
  errorMessage: string;
}

const SubmitErrorPage = ({ handleOnStartOver, errorMessage }: SubmitErrorPageProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Result
      icon={<img src={ClaimSubmitErrorIcon} />}
      title={t('newClaim.claimFailure.failedToSubmit')}
      extra={
        <Space direction="vertical" size="middle" style={{ width: '30.5rem' }}>
          <Paragraph>{errorMessage}</Paragraph>
          <Space>
            <PrimaryButton onClick={handleOnStartOver}>{t('newClaim.claimFailure.startAgain')}</PrimaryButton>
            <SecondaryButton onClick={() => navigate('/')}>{t('newClaim.claimFailure.returnToHome')}</SecondaryButton>
          </Space>
        </Space>
      }
    />
  );
};

export default SubmitErrorPage;
